var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDam = function SvgDam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M3.429 23C2.337 23 1 22.276 1 20.889V3.11C1 1.725 2.337 1 3.429 1H20.57C21.663 1 23 1.725 23 3.111V20.89c0 1.386-1.337 2.11-2.429 2.11zm8.821-11.25H22V3.111C22 2.497 21.36 2 20.571 2H12.25zM3.429 22h8.321v-9.75H2v8.639C2 21.503 2.64 22 3.429 22",
    clipRule: "evenodd",
    vectorEffect: "non-scaling-stroke"
  })));
};
export { SvgDam as ReactComponent };
export default __webpack_public_path__ + "90f886f45adaee20a1747df492bb561c.svg";